import { render, staticRenderFns } from "./on-screen-dashboard.vue?vue&type=template&id=7db0db00"
import script from "./on-screen-dashboard.vue?vue&type=script&lang=js"
export * from "./on-screen-dashboard.vue?vue&type=script&lang=js"
import style0 from "./on-screen-dashboard.vue?vue&type=style&index=0&id=7db0db00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports